var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('AppBar',{attrs:{"immersive":""}}),(_vm.data)?_c('UITemplate',{attrs:{"data":_vm.data,"current-notify-key":_vm.currentNotifyKey},on:{"reTry":_vm.reTry}}):_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }